<template>
  <g>
    <g
     transform="translate(0,-287.73958)"
    >
      <rect
        y="287.69235"
        x="-8.6736174e-019"
        height="9.307663"
        width="1.9336753"
        id="rect815-3-1"
        fill="white" />
      <rect x="0" y="287.69235" width="18.5357763" height="9.307663" fill="white" />
      <g :fill="getCssColor(color)"
        id="g1067">
        <rect
          id="rect815-3-58"
          width="0.39687541"
          height="9.307663"
          x="4.1010451"
          y="287.69232" />
        <rect
          id="rect815-3-5-1"
          width="0.39687541"
          height="9.307663"
          x="5.6885405"
          y="287.69232" />
        <rect
          id="rect815-3-58-6-7"
          width="0.39687541"
          height="9.307663"
          x="4.894793"
          y="287.69232" />
        <rect
          id="rect815-3-5-1-5-5"
          width="0.39687541"
          height="9.307663"
          x="6.4822917"
          y="287.69232" />
        <rect
          id="rect815-3-58-1"
          width="0.39687541"
          height="9.307663"
          x="7.2760448"
          y="287.69235" />
        <rect
          id="rect815-3-5-1-1"
          width="0.39687541"
          height="9.307663"
          x="8.8635397"
          y="287.69235" />
        <rect
          id="rect815-3-58-6-7-4"
          width="0.39687541"
          height="9.307663"
          x="8.0697947"
          y="287.69235" />
        <rect
          id="rect815-3-5-1-5-5-3"
          width="0.39687541"
          height="9.307663"
          x="9.6572914"
          y="287.69235" />
      </g>
      <g :fill="getCssColor(color)"
        id="g1057">
        <rect
          id="rect815"
          width="3.7041667"
          height="8.5097332"
          x="0"
          y="288.08936" />
        <rect
          id="rect815-5"
          width="8.4816093"
          height="9.307663"
          x="10.054167"
          y="287.69235" />
      </g>
      <g fill="white"
        id="g1101">
        <g
          id="g1089">
          <rect
            y="287.69232"
            x="3.7041667"
            height="9.307663"
            width="0.39687541"
            id="rect815-3" />
          <rect
            y="287.69232"
            x="5.2916694"
            height="9.307663"
            width="0.39687541"
            id="rect815-3-5" />
          <rect
            y="287.69232"
            x="4.4979177"
            height="9.307663"
            width="0.39687541"
            id="rect815-3-58-6"
            />
          <rect
            y="287.69232"
            x="6.0854163"
            height="9.307663"
            width="0.39687541"
            id="rect815-3-5-1-5"
            />
          <rect
            y="287.69235"
            x="6.8791671"
            height="9.307663"
            width="0.39687541"
            id="rect815-3-50"
            />
          <rect
            y="287.69235"
            x="8.4666681"
            height="9.307663"
            width="0.39687541"
            id="rect815-3-5-3"
            />
          <rect
            y="287.69235"
            x="7.6729207"
            height="9.307663"
            width="0.39687541"
            id="rect815-3-58-6-2"
            />
          <rect
            y="287.69235"
            x="9.260417"
            height="9.307663"
            width="0.39687541"
            id="rect815-3-5-1-5-6"
            />
        </g>
        <rect
          id="rect815-3-5-1-5-6-5"
          width="1.0583333"
          height="4.2333331"
          x="16.923515"
          y="290.22949" />
      </g>
      <g fill="black"
        id="g1053">
        <rect
          id="rect815-3-5-1-5-6-8"
          width="0.39687541"
          height="9.307663"
          x="287.69235"
          y="-11.248234"
          transform="rotate(90)" />
        <rect
          id="rect815-3-5-1-5-6-8-1"
          width="0.39687541"
          height="9.307663"
          x="296.60315"
          y="-11.248234"
          transform="rotate(90)" />
      </g>
    </g>
  </g>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'getCssColor'
    ])
  },
  props: {
    color: String
  }

}
</script>

<style>

</style>
